import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'lingui-react';

import Tooltip from 'elements/Tooltip';

import StatusCircle from './StatusCircle';
import StatusIcon from './StatusIcon';
import StatusValue from './StatusValue';

const DEFAULT_COLOR = 'green';

export function StatusLabel({ color: rawColor, label, showIcon, tooltip }) {
  const color = rawColor || DEFAULT_COLOR;
  const target = (
    <div>
      {
        showIcon
          ? <StatusIcon color={color} />
          : <StatusCircle color={color} />
      }
      { label &&
        <StatusValue>
          <Trans id={label} />
        </StatusValue>
      }
    </div>
  );
  if (!tooltip) return target;
  return (
    <Tooltip
      position="top"
      message={() => (
        <Trans id={tooltip} />
      )}
    >
      {target}
    </Tooltip>
  );
}

StatusLabel.propTypes = {
  color: PropTypes.string,
  label: PropTypes.string,
  showIcon: PropTypes.bool,
  tooltip: PropTypes.string,
};

StatusLabel.defaultProps = {
  color: DEFAULT_COLOR,
  showIcon: false,
  tooltip: null,
  label: null,
};

export default StatusLabel;



// WEBPACK FOOTER //
// ./components/StatusLabel/index.js